import { FC, ReactElement } from 'react';

import { useIsBetConfirmedConnected } from '../../components/gameGrid/hooks';
import { Bets } from '../../config/bets';
import { useAutoCashoutSlice } from '../../store/slices/autocashout/selectors';
import { useCrashAutoplaySlice } from '../../store/slices/crashAutoplay/selectors';
import { useHighflyerGameStateSlice } from '../../store/slices/highflyerGame/selectors';
import { useHighflyerStateSlice } from '../../store/slices/highflyerState/selectors';

import { FloatingBetStatus } from './FloatingBetStatus';

interface FloatingBetStatusProps {
  betCode: Bets;
}
export const FloatingBetStatusConnected: FC<FloatingBetStatusProps> = ({ betCode }): ReactElement | null => {
  const isBetConfirmed = useIsBetConfirmedConnected(betCode);
  const { isEnabled, cashoutMultiplier } = useAutoCashoutSlice.getAutoCashoutObj(betCode);
  const isScrollBarAtTop = useHighflyerGameStateSlice.isTabScrollbarAtTop();
  const isAutoPlayEnabled = useCrashAutoplaySlice.isInProgress(betCode);
  const isInfiniteAutoPlayEnabled = useCrashAutoplaySlice.getInfiniteAutoplayEnabled(betCode) || false;
  const cashedAmount = useHighflyerStateSlice.getCashedAmount(betCode);
  if (!isBetConfirmed && cashedAmount === 0) return null;
  return (
    <FloatingBetStatus
      betCode={betCode}
      isAutocashEnabled={isEnabled}
      cashoutMultiplier={cashoutMultiplier}
      isAutoPlayEnabled={isAutoPlayEnabled}
      hideAutoPlayAutoCashout={isScrollBarAtTop}
      isInfiniteAutoPlayEnabled={isInfiniteAutoPlayEnabled}
    />
  );
};
